module.exports = __webpack_public_path__ + "static/cinsa_tu_calentador_ideal_familia_cinsa_S-9f12a86f7d7f919061d668a99226e7bb.png";